var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUncheckedAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5210_482187)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4.17065C1.33481 4.58249 0.5 5.69373 0.5 6.99995V16.9999C0.5 18.6568 1.84315 19.9999 3.5 19.9999H13.5C14.8067 19.9999 15.9182 19.1646 16.3297 17.9988H15.2331C14.8875 18.5972 14.2408 18.9999 13.5 18.9999H3.5C2.39543 18.9999 1.5 18.1045 1.5 16.9999V6.99995C1.5 6.25967 1.9022 5.61332 2.5 5.26751V4.17065Z",
    fill: "#1F85CF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    stroke: "#1F85CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5210_482187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedAll);
export default __webpack_public_path__ + "static/media/UncheckedAll.7a63bb1fd16c5fc3e6a7a3aec16a20e6.svg";
export { ForwardRef as ReactComponent };